import { render } from "./select-star.html?vue&type=template&id=da75df02&scoped=true&ts=true"
import script from "./select-star.ts?vue&type=script&lang=ts"
export * from "./select-star.ts?vue&type=script&lang=ts"

import "./select-star.scss?vue&type=style&index=0&id=da75df02&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da75df02"]])

export default __exports__